<!-- Broadband label for phone start -->
<div class="broadband-desktop-view" *ngIf="labelResponse?.length && !isGrandFatheredLabel">
    <xm-fcc-card page="line-details-cbm">
        <xm-broadband-header [cbmLabelContent]="cbmLabelContent"></xm-broadband-header>
        <div class ="notification-banner" *ngIf="showretiredBanner()">
            <xm-media-image [imageOptions]="infoIconGrey" size="width" class="icon"></xm-media-image>
            <cms-text [broadbandHeaderLink]="true" [originalText]="cbmLabelContent.bannerDescription"></cms-text>
        </div>
        <div class="broadband-mobile-view">
            <button *ngFor="let item of availableTabs" class="fcc-tab-label column-{{labelResponse?.length}}" [ngClass]="{ 'active': activeTabPlanId === item?.planId }" (click)="tabChange(item?.planId)">{{ item?.name }}</button>
        </div>
        <cbm-nutrition-label
            class="fcc-label column-{{labelResponse?.length}}"
            *ngFor="let label of labelResponse"
            [ngClass]="{ 'active-label': activeTabPlanId === label?.planId }"
            [isInUse]="activePlanId === label?.planId"
            [response]="label"
            [isLineDetailsBBL]="true">
        </cbm-nutrition-label>
    </xm-fcc-card>
</div>
<!-- Broadband label for phone end -->

<!-- Broadband banner for Grand father for phone start -->
<div class="header-section" *ngIf="isGrandFatheredLabel">
    <xm-broadband-header [cbmLabelContent]="cbmLabelContent" [isGrandFatheredLabel]="isGrandFatheredLabel" [infoIconGrey]="infoIconGrey"></xm-broadband-header>
</div>
<!-- Broadband banner for Grand father phone end -->

